<template>
  <custom-dialog width="530px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <div class="item-tip" v-if="model.type === 'update'">
        <i class="icon icon-tishi"></i>
        <span>{{ $t('dms_websiteDialog.zdsjhkjczdjdtgxgqtsb') }}</span>
      </div>
      <el-form :model="form" :rules="rules" ref="form" label-position="top">
        <el-form-item :label="$t('dms_websiteDialog.zhan_dian_ming_cheng')">
          <el-input placeholder="" v-model="form.siteName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_websiteDialog.shi_yong_shi_qu')" prop="timezone" v-if="model.type !== 'update'">
          <custom-select type="tree" v-model="form.timezone" code="roc_timezone" placeholder="" :dataFilter="pathTransTree" :props="{ label: 'name', value: 'value' }"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('dms_websiteDialog.mo_ren_yu_yan')" prop="defaultLocale" v-if="model.type !== 'update'">
          <custom-select code="roc_default_locale" v-model="form.defaultLocale"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('dms_websiteDialog.suo_shu_zu_zhi')" prop="orgId" v-if="model.type !== 'update'">
          <custom-select
            :disabled="model.type === 'stockAdd' || model.type === 'edit'"
            v-model="form.orgId"
            :props="{ label: 'orgName', value: 'orgId' }"
            url="OrganOpenAllList"
            ref="org"
            @change="changeOrg"
          ></custom-select>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button size="small" type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      selectRow: {},
      form: {
        siteName: '',
        timezone: [],
        defaultLocale: '',
        orgId: '',
        orgName: '',
      },
    };
  },
  mounted() {
    this.initDialog();
  },

  computed: {
    rules() {
      return {
        siteName: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]) },
        ],
        timezone: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        orgId: {
          required: true,
          message: this.$t('Common.com_required'),
        },
      };
    },
  },
  methods: {
    // 路径字符串转树
    pathTransTree(arr) {
      let list = arr.map((t) => t.value);
      list = list.map((t) => t.split('/').map((f, i) => ({ name: f, value: f, parent: i ? t.split('/')[i - 1] : 0 })));
      list = list.reduce((pre, item) => [...pre, ...item], []);
      list = [...new Set(list.map((t) => JSON.stringify(t)))].map((f) => JSON.parse(f));
      const tree = list.filter((parent) => {
        const branchArr = list.filter((child) => parent.name === child.parent);
        if (branchArr.length > 0) {
          parent.children = branchArr;
        }
        return parent.parent === 0;
      });
      return tree;
    },
    // 初始化
    initDialog: function () {
      if (this.model.type === 'edit') {
        this.selectRow = this.model.row;
        this.$setFormatData(this.form, this.model.row);
        this.form.timezone = this.model.row.timezone ? this.model.row.timezone.split('/') : [];
      }
      if (this.model.type === 'update') {
        this.rules.timezone.required = false;
      }
      if (this.model.type === 'stockAdd') {
        this.form.orgId = this.model.row.orgId;
        this.form.orgName = this.model.row.orgName;
        return;
      }
      if (!this.form.orgId) {
        if (this.$store.state.userInfo && this.$store.state.userInfo.rootOrgId) {
          this.form.orgId = this.$store.state.userInfo.rootOrgId;
        }
      }
    },
    // 确认保存
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.model.type === 'add' || this.model.type === 'stockAdd') {
          this.saveInsert();
        }
        if (this.model.type === 'edit') {
          this.saveUpdate();
        }
        if (this.model.type === 'update') {
          this.saveUpdateSite();
        }
      });
    },
    // 保存新增
    saveInsert: function () {
      const reqData = this.getReqData('edit');
      this.$postJSON(apis.SiteAdd, reqData, true).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
    // 保存编辑
    saveUpdate: function () {
      const reqData = this.getReqData('edit');
      this.$postJSON(apis.SiteUpdate, reqData, true).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('success', this.form);
        this.visible = false;
      });
    },
    // 变更组织
    changeOrg(row) {
      this.form.orgName = row.orgName;
    },
    getReqData(type) {
      const ret = {
        ...this.form,
      };
      const timezone = this.form.timezone.join('/');
      // const checkNodes = this.$refs.org.getCheckedNodes();
      // if (checkNodes.length) {
      //   const lastNode = checkNodes[checkNodes.length - 1];
      //   ret.orgId = lastNode.orgId;
      //   ret.orgName = lastNode.orgName;
      // }
      ret.timezone = timezone;
      if (type === 'edit') {
        ret.siteId = this.selectRow.siteId;
      }
      return ret;
    },
    // 站点升级
    saveUpdateSite: function () {
      this.$postJSON(apis.stockSiteUpgrade, { bodyNum: this.model.row.bodyNum, siteName: this.form.siteName }).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.visible = false;
        this.$emit('success', this.form);
      });
    },
  },
};
</script>

<style lang="scss"></style>
